import { FormControlLabel, Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import React from 'react';
import { WO2Checkbox, WO2ToggleSwitch } from 'src/common';
import DateRangePicker from 'src/common/components/DateRangePicker';
import { ActionCreatorWithoutPayload, ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { BaseReportComponentProps, MdaReportTypes } from '../../store/types';
import { DateRange } from 'src/store';
import { ExpandMore } from '@mui/icons-material';

export interface UnrealisedCapitalGainsAndLossesProps extends BaseReportComponentProps {
  setCapitalGainsLossesUnrealisedSelectedParameter: ActionCreatorWithPayload<boolean, string>;
  setAsAtDateCapitalGainsLossesUnrealisedParameter: ActionCreatorWithPayload<DateRange, string>;
  expandGainsAndLossesUnrealised: ActionCreatorWithoutPayload<string>;
  setUnrealisedCapitalAndGainsExcludeFxParameter: ActionCreatorWithPayload<boolean, string>;
}

export const UnrealisedCapitalGainsAndLosses = ({
  parameters,
  createReportSortRequest,
  setCapitalGainsLossesUnrealisedSelectedParameter,
  setAsAtDateCapitalGainsLossesUnrealisedParameter,
  setUnrealisedCapitalAndGainsExcludeFxParameter,
  expandGainsAndLossesUnrealised,
}: UnrealisedCapitalGainsAndLossesProps): JSX.Element => {
  const handleClickGainsLossesUnrealisedSelect = () => {
    setCapitalGainsLossesUnrealisedSelectedParameter(!parameters.selectedReports?.unrealisedCapitalGainsAndLosses.selected);
    createReportSortRequest(
      !parameters.selectedReports?.unrealisedCapitalGainsAndLosses.selected,
      MdaReportTypes.UnrealisedCapitalGainsAndLosses.id,
      MdaReportTypes.UnrealisedCapitalGainsAndLosses.displayName
    );
  };

  const handleClickDateForGainsLossesUnrealised = (dates: DateRange) => {
    setAsAtDateCapitalGainsLossesUnrealisedParameter(dates);
  };

  return (
    <Accordion
      onChange={expandGainsAndLossesUnrealised}
      expanded={parameters.selectedReports?.unrealisedCapitalGainsAndLosses.expanded || false}
      elevation={0}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FormControlLabel
          sx={{ flex: 1 }}
          aria-label="Acknowledge"
          onClick={(event) => event.stopPropagation()}
          onFocus={(event) => event.stopPropagation()}
          control={
            <WO2Checkbox
              color="primary"
              checked={parameters.selectedReports?.unrealisedCapitalGainsAndLosses.selected}
              onChangeHandler={handleClickGainsLossesUnrealisedSelect}
            />
          }
          label="Unrealised Capital Gains and Losses"
        />
        <div onClick={(e) => e.stopPropagation()}>
          <DateRangePicker
            sx={{ minWidth: 194 }}
            dateRange={{
              dateFrom: '',
              dateTo: parameters?.selectedReports.unrealisedCapitalGainsAndLosses?.asAtDate,
              dateRangeType: parameters?.selectedReports.unrealisedCapitalGainsAndLosses?.asAtDateType,
            }}
            dateOnlyLabel="As at"
            setDateRange={handleClickDateForGainsLossesUnrealised}
            isDateOnly={true}
          />
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="flex" flexWrap="nowrap" alignItems="center">
          <WO2ToggleSwitch
            checked={parameters.selectedReports.unrealisedCapitalGainsAndLosses.excludeFxGainsLosses}
            onChange={(_, checked: boolean) => {
              setUnrealisedCapitalAndGainsExcludeFxParameter(checked);
            }}
            color="primary"
            name="hidingOptions"
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          <Typography variant="h4">Exclude FX Gains/Losses</Typography>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
